import { lazy } from 'react';

export const PlayerStreetForm = lazy(() => import('./PlayerStreetForm'));
